<template>
  <div class="container">
    <div class="text-danger">{{error}}</div>
  </div>
</template>

<script>
import $backend from '../backend'

export default {
  name: 'webhook',
  data () {
    return {
      resources: [],
      error: ''
    }
  },
  beforeMount () {

  },
  created () {
    let code = this.$route.query.code
    let client = this.$route.query.client || 'strava'

    if (code && code !== 'undefined') {
      $backend.exchangeToken(client, code).then(responseData => {
        localStorage.setItem('athlete', JSON.stringify(responseData.data))
        this.$store.commit('setIsLoggedIn', true)

        // Check if there's a pending event to redirect to
        const pendingEvent = localStorage.getItem('pendingEvent')
        if (pendingEvent) {
          try {
            const eventData = JSON.parse(pendingEvent)
            console.log('Found pending event:', eventData)
            // Check if the pending event is not too old (24 hours)
            if (Date.now() - eventData.timestamp < 24 * 60 * 60 * 1000) {
              // Clear the pending event and redirect to the event
              localStorage.removeItem('pendingEvent')
              console.log('Redirecting to pending event:', eventData.slug)
              this.$router.replace({ name: 'eventDetail', params: { slug: eventData.slug } })
              return
            } else {
              // Clear expired pending event
              console.log('Pending event expired, clearing')
              localStorage.removeItem('pendingEvent')
            }
          } catch (e) {
            // Clear invalid pending event data
            console.log('Invalid pending event data, clearing')
            localStorage.removeItem('pendingEvent')
          }
        }

        // Check if there's a redirect URL to go back to after login
        const redirectUrl = localStorage.getItem('redirectUrl')
        if (redirectUrl) {
          try {
            console.log('Found redirect URL:', redirectUrl)
            // Clear the redirect URL and redirect to the saved page
            localStorage.removeItem('redirectUrl')
            this.$router.replace(redirectUrl)
            return
          } catch (e) {
            // Clear invalid redirect URL data
            console.log('Invalid redirect URL data, clearing')
            localStorage.removeItem('redirectUrl')
          }
        }

        // Default redirect to home if no pending event or redirect URL
        this.$router.replace({ name: 'home' })
      }).catch(error => {
        this.error = error.data.msg
      })
    } else {
      this.error = 'Missing or invalid code parameter'
    }
  },
  methods: {
  }
}

</script>

<style lang="scss">
</style>
